<template>
    <v-col
        cols="12"
        sm="12"
        md="6"
        lg="4"
        class="pa-0"
        tile
    >
        <v-card
            light
            outlined
            tile
            color="#fff"
        >
            <v-card-title class="w-100">
                <span class="text-h6 font-weight-light">Leads</span>
                <v-spacer></v-spacer>
                <div class="text-end pa-2">
                    <v-select
                        v-model="filter.range"
                        :items="items"
                        label="Date Range"
                        dense
                        width="100"
                        hide-details
                        @change="getData"
                    ></v-select>
                </div>
            </v-card-title>

            <v-card-text>
                <Bar
                    v-if="loaded"
                    :chart-options="chartOptions"
                    :chart-data="chartData"
                    :chart-id="chartId"
                    :dataset-id-key="datasetIdKey"
                    :plugins="plugins"
                    :css-classes="cssClasses"
                    :styles="styles"
                    :width="width"
                    :height="height"
                />
            </v-card-text>

            <v-card-actions class="w-100 blue lighten-5">
                <v-list-item class="grow">
                    <v-row
                    align="center"
                    justify="start"
                    >
                        <v-icon class="mr-1" color="green" v-if="chartData.icon == 'mdi-arrow-up-bold'">
                            {{ chartData.icon }}
                        </v-icon>
                        <v-icon class="mr-1" color="red" v-else-if="chartData.icon == 'mdi-arrow-down-bold'">
                            {{ chartData.icon }}
                        </v-icon>
                        <span class="subheading mr-2" v-if="chartData.percentage != 'Insufficient Data'">
                            <ICountUp
                            :delay="delay"
                            :endVal="chartData.percentage"
                            :options="options"
                            /> Confirmed Leads
                        </span>
                        <span class="subheading mr-2" v-else>{{ chartData.percentage }}</span>
                    </v-row>
                    <v-spacer></v-spacer>
                    <v-row
                    align="center"
                    justify="end"
                    >
                        <v-icon class="mr-1" color="green" v-if="chartData.uc_icon == 'mdi-arrow-up-bold'">
                            {{ chartData.uc_icon }}
                        </v-icon>
                        <v-icon class="mr-1" color="red" v-else-if="chartData.uc_icon == 'mdi-arrow-down-bold'">
                            {{ chartData.uc_icon }}
                        </v-icon>
                        <span class="subheading mr-2" v-if="chartData.uc_percentage != 'Insufficient Data'">
                            <ICountUp
                            :delay="delay"
                            :endVal="chartData.uc_percentage"
                            :options="options"
                            /> Under Contract
                        </span>
                        <span class="subheading mr-2" v-else>{{ chartData.uc_percentage }}</span>
                    </v-row>
                </v-list-item>
            </v-card-actions>

        </v-card>
    </v-col>
</template>

<script>
import axios from 'axios'
import ICountUp from 'vue-countup-v2'
import { Bar } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
    name: 'BarChart',
    components: {
        Bar,
        ICountUp
    },
    props: {
        chartId: {
            type: String,
            default: 'bar-chart'
        },
        datasetIdKey: {
            type: String,
            default: 'label'
        },
        width: {
            type: Number,
            default: 400
        },
        height: {
            type: Number,
            default: 400
        },
        cssClasses: {
            default: '',
            type: String
        },
        styles: {
            type: Object,
            default: () => {}
        },
        plugins: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            chartData: null,
            items: ['7 Days', '30 Days', '6 Months', '12 Months'],
            filter: {
                range: '7 Days',
            },
            loaded: false,
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false
            },
            percentage: '',
            uc_percentage: '',
            icon: '',
            uc_icon: '',
            delay: 1000,
            options: {
                useEasing: true,
                useGrouping: true,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: '%'
            },
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        async getData() {
            this.loaded = false

            try {
                await axios.get('crm/leads/chart', {
                    params: this.filter
                })
                .then(response => {
                    this.loaded = true
                    this.chartData = response.data
                    this.$nextTick()
                })
            } catch (e) {
                console.error(e)
            }
        },
    }
}
</script>
<style lang="sass">
span.subheading.mr-2 span
    color: #000
    font-weight: bold
    font-size: 1.3em

.mdi-arrow-down-bold + .subheading span
    color: #f44336!important

.mdi-arrow-up-bold + .subheading span
    color: #4caf50!important
</style>